const voiceIdEngines = {
  Amy: 'neural',
  Emma: 'neural',
  Brian: 'neural',
  Ivy: 'neural',
  Joanna: 'neural',
  Kendra: 'neural',
  Kimberly: 'neural',
  Salli: 'neural',
  Joey: 'neural',
  Justin: 'neural',
  Kevin: 'neural',
  Matthew: 'neural',
  Geraint: 'standard',
  Conchita: 'standard',
  Lucia: 'neural',
  Enrique: 'standard',
  Lupe: 'neural',
  Penelope: 'standard',
  Miguel: 'standard'
};

module.exports = voiceIdEngines;
